/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListContext {
    getFixupPrototypeFunction() { return ListContext.fixupPrototype; }

    static newInstance(model: Partial<ListContext>): ListContext {
        let obj = Object.assign(new ListContext(), model);
        ListContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListContext>): ListContext {
        if (!model) return null;
        return ListContext.newInstance(<ListContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListContext) {
        if (!obj) return;

        models.ListContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListContext): boolean {
        Object.setPrototypeOf(obj, ListContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.batch_size === undefined) {
            this.batch_size = 0;
        }
        if (this.batch_offset === undefined) {
            this.batch_offset = 0;
        }
        if (this.total === undefined) {
            this.total = 0;
        }
    }

    /**
     * Max number of ids in the response
     */
    batch_size: number;

    /**
     * Offset of batches into the results. First batch is 0
     */
    batch_offset: number;

    /**
     * Total number of results
     */
    total: number;

}
